import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Hombres que se levantan múltiples veces por noche y sienten que su sueño está fragmentado.', 'Quienes sienten que no vacían completamente su vejiga antes de dormir.', 'Hombres que experimentan fatiga diurna debido a interrupciones nocturnas constantes.', 'Quienes buscan un enfoque práctico y basado en hábitos para complementar su cuidado personal.'];
  const notForWho = ['Quienes buscan un diagnóstico médico o tratamiento para condiciones graves (consulte a su médico).', 'Hombres que no están dispuestos a hacer pequeños ajustes en su rutina nocturna.', 'Quienes buscan una "solución mágica" instantánea sin aplicar consistencia.'];
  return <section className="bg-navy-950 py-20 md:py-28 relative text-cream-50 border-y border-navy-800" data-id="element-14">
      <div className="container mx-auto px-4" data-id="element-15">
        <div className="max-w-[900px] mx-auto" data-id="element-16">
          <FadeIn data-id="element-17">
            <div className="text-center mb-16" data-id="element-18">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-19">
                Para quién es esta guía
              </h2>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-20">
            <FadeIn delay={0.1} data-id="element-21">
              <div className="bg-navy-900 rounded-3xl p-8 md:p-10 border border-navy-800 shadow-xl h-full" data-id="element-22">
                <h3 className="text-2xl font-heading font-bold text-white mb-8 flex items-center gap-3" data-id="element-23">
                  <div className="w-10 h-10 rounded-full bg-gold-500/10 flex items-center justify-center" data-id="element-24">
                    <Check className="text-gold-400" size={20} data-id="element-25" />
                  </div>
                  Diseñado para
                </h3>
                <ul className="space-y-6" data-id="element-26">
                  {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-27">
                      <div className="w-1.5 h-1.5 rounded-full bg-gold-500/50 mt-2.5 shrink-0" data-id="element-28" />
                      <span className="text-cream-100/80 leading-relaxed" data-id="element-29">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-30">
              <div className="bg-navy-900 rounded-3xl p-8 md:p-10 border border-navy-800 shadow-xl h-full opacity-80" data-id="element-31">
                <h3 className="text-2xl font-heading font-bold text-white mb-8 flex items-center gap-3" data-id="element-32">
                  <div className="w-10 h-10 rounded-full bg-navy-800 flex items-center justify-center border border-navy-700" data-id="element-33">
                    <X className="text-cream-100/40" size={20} data-id="element-34" />
                  </div>
                  No es para
                </h3>
                <ul className="space-y-6" data-id="element-35">
                  {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-36">
                      <div className="w-1.5 h-1.5 rounded-full bg-navy-700 mt-2.5 shrink-0" data-id="element-37" />
                      <span className="text-cream-100/60 leading-relaxed" data-id="element-38">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}